import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { useLang } from "../contexts/LanguageContext";
import { waLink } from "../lib/contact";

export default function CTASection({ onOpenLead, id = "contact" }) {
  const { t } = useLang();
  return (
    <section id={id} className="py-20 md:py-28 bg-slate-50" data-testid="cta-section">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-[32px] overflow-hidden bg-gradient-to-br from-blue-600 via-violet-600 to-fuchsia-500 p-10 md:p-16 text-white"
        >
          <div className="absolute inset-0 grain opacity-30" />
          <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-white/20 blur-3xl" />
          <div className="absolute -bottom-32 -left-20 w-96 h-96 rounded-full bg-fuchsia-300/30 blur-3xl" />

          <div className="relative">
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight max-w-3xl">
              {t.cta.title}
            </h2>
            <p className="mt-5 text-white/85 text-base md:text-lg max-w-2xl">{t.cta.sub}</p>
            <div className="mt-9 flex flex-wrap gap-3">
              <Button
                onClick={onOpenLead}
                data-testid="footer-cta-primary"
                className="h-13 px-7 py-6 rounded-full bg-white text-slate-950 hover:bg-white/90 text-base font-semibold"
              >
                {t.cta.primary}
                <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-cta-whatsapp"
                className="inline-flex items-center gap-2 h-12 px-6 rounded-full border border-white/40 hover:bg-white/10 text-base font-semibold transition"
              >
                <MessageCircle className="w-5 h-5" />
                {t.cta.secondary}
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
